export default "__VITE_ASSET__C0Rs$0ho__";